import { currentDeviceSaga } from "./current-device/sagas";
import { fullDevicesLoadSaga } from "./full-devices/sagas";
import { paramMappingsSaga } from "./param-mappings/sagas";
import { versionsSaga } from "./versions/sagas";

// Load any ui-state specific sagas here.
const globalPageSagas = [
  currentDeviceSaga(),
  fullDevicesLoadSaga(),
  paramMappingsSaga(),
  versionsSaga(),
];

export { globalPageSagas };
